import { useMemo } from "react";
import BaseFilters from "../../../../../components/shared/filters/Filters";
import { useHomeFilters } from "../../hooks/filters/useHomeFilters";
import { useTeamFilters } from "../../hooks/filters/useTeamFilters";
import { useScheduleContext } from "../../hooks/context/useScheduleContext";
import { usePreferences } from "../../../../Settings/Configuration/hooks/usePreferences";
import { SCHEDULE_PREFERENCE_KEYS } from "../../constants/scheduleTypes";

function Filters() {
    const { type } = useScheduleContext();
    const homeFilters = useHomeFilters();
    const teamFilters = useTeamFilters();
    const config = useMemo(() => {
        if (["team", "template", "profile"].includes(type)) {
            return teamFilters;
        } else {
            return homeFilters;
        }
    }, [type, teamFilters, homeFilters]);

    const defaultFilterPreference = usePreferences(`${SCHEDULE_PREFERENCE_KEYS[type]}.defaultFilter`);

    return (
        <BaseFilters
            defaultFilter={defaultFilterPreference}
            config={config}
        />
    );
}

export default Filters;
